export const setShowDTP = (displayDTP) => ({
  type: "SET_DTP_DISPLAY",
  displayDTP: displayDTP,
});
export const setDTPClients = (ctids) => ({
  type: "SET_DTP_CLIENTS",
  ctids: ctids,
});
export const setDTPClientGroups = (groups) => ({
  type: "SET_DTP_CLIENT_GROUPS",
  groups: groups,
});
export const setDowntimeMessage = (message) => ({
  type: "SET_DOWNTIME_MESSAGE",
  downtime_message: message,
});
export const setNotificationMessage = (message) => ({
  type: "SET_NOTIFICATION_MESSAGE",
  notification_message: message,
});
export const setSelectedClients = (clients) => ({
  type: "SET_SELECTED_CLIENTS",
  clients: clients,
});
export const setSelectedClientGroups = (groups) => ({
  type: "SET_SELECTED_CLIENT_GROUPS",
  groups: groups,
});
export const setDTPDetails = (dtp) => ({
  type: "SET_DTP_DETAILS",
  dtp: dtp,
});
export const setSummaryDetails = (dtp) => ({
  type: "SET_SUMMARY_DETAILS",
  dtp: dtp,
});
export const resetDTP = () => ({
  type: "RESET_DTP_FIELDS",
});
export const toggleSummaryConfirm = (disableConfirmCallback) => ({
  type: "TOGGLE_SUMMARY_CONFIRM",
  disableConfirmCallback: disableConfirmCallback,
});
export const toggleSummaryModal = (modalOpen, modalState) => ({
  type: "TOGGLE_SUMMARY_MODAL",
  modalOpen: modalOpen,
  modalState: modalState,
});
export const setNewDate = (whatToSet, dateString) => ({
  type: "SET_DTP_NEW_DATE",
  whatToSet: whatToSet,
  dateString: dateString,
});
export const setNewTime = (whatToSet, timeString, timeZoneOverride) => ({
  type: "SET_DTP_NEW_TIME",
  whatToSet: whatToSet,
  timeString: timeString,
  timeZoneOverride: timeZoneOverride,
});
export const setTitle = (title) => ({
  type: "SET_TITLE",
  title: title,
});
export const setDTPSessions = (action, sessions, clients) => ({
  type: "SET_DTP_SESSIONS",
  dtpAction: action,
  sessions: sessions,
  clients: clients,
});
export const cancelDTPSession = (id, status) => ({
  type: "CANCEL_DTP_SESSION",
  id: id,
  status: status
});
